import { memo } from 'react';
import { IJackpotGame, IJackpotPlayerObject } from '@api/types/jackpot';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { formatThousandNumber } from '@utils/utils';
import { calcChanceToWin, generateRandomColorsFromUid } from '@utils/jackpot';
import FairnessIcon from '@assets/png/fairness.png';
import Avatar from '@components/avatar';
import InfoCard from '@components/info-card';
import Labeler from '@components/labeler';
import styles from './recent.module.scss';
import ColorfulSeparator from '../components/colorful-separator';
import { JACKPOT_PLAYER_COLORS } from '@consts/jackpot';
export interface IRecentGameItemProps {
    game: IJackpotGame;
}

const RecentGameItem = ({
    game: { uid, players, winner_id, reward, bank, stakes, roll_stake },
}: IRecentGameItemProps): JSX.Element | null => {
    const winner: IJackpotPlayerObject | undefined = players.find((player) => {
        return player.user.id === winner_id;
    })!;
    const winnerIndex = players.findIndex((player) => {
        return player.user.id === winner_id;
    });

    const {
        total_stake,
        user: { avatar_url, username },
    } = winner;

    const COLORS: string[] = generateRandomColorsFromUid(uid).map(
        (i) => JACKPOT_PLAYER_COLORS[i],
    );

    let currentColor: number = 0;
    const playersColor: { id: string; color: string }[] = players.map(
        (player, index) => {
            currentColor++;
            if (currentColor > COLORS.length - 1) currentColor = 0;
            return {
                id: player.user.id,
                color:
                    index > COLORS.length - 1
                        ? COLORS[currentColor]
                        : COLORS[index],
            };
        },
    );

    const winnerColor = playersColor[winnerIndex].color;

    return (
        <div className={styles.item}>
            <header className={styles.item__header}>
                <h6>Game #{uid} Winner</h6>
                <div>
                    <img src={FairnessIcon} alt="" />
                </div>
            </header>
            <div className={styles.body}>
                <div className={styles.result}>
                    <Avatar
                        src={avatar_url}
                        alt={username}
                        width="64"
                        borderColor={
                            winnerColor
                                ? winnerColor.slice(1, winnerColor.length)
                                : 'black'
                        }
                    />
                    <InfoCard
                        color="yellow-gradient"
                        text={`${calcChanceToWin({ bank, total_stake })}%`}
                        className={styles.result__chance}
                    />
                </div>
                <div className={styles.data}>
                    <Labeler label="Deposited">
                        <InfoCard
                            color="dark-gradient"
                            icon={<CoinIcon />}
                            text={(total_stake / 100).toString()}
                            className={styles.data__card}
                        />
                    </Labeler>
                    <Labeler label="Ticket">
                        <InfoCard
                            color="dark-gradient"
                            text={`#${formatThousandNumber(roll_stake)}`}
                            className={styles.data__card}
                        />
                    </Labeler>
                </div>
            </div>
            <ColorfulSeparator
                COLORS={COLORS}
                players={players}
                stakes={stakes}
                total_stakes={bank}
                gameUid={uid}
                isCurrent={false}
            />
            <footer className={styles.item__footer}>
                <div
                    className={styles.triangle}
                    style={{
                        left: `${(roll_stake / bank) * 100}%`,
                    }}
                />
                <span>Prize</span>
                <CoinIcon />
                <span>{reward}</span>
            </footer>
        </div>
    );
};

export default memo(RecentGameItem);
